import React from 'react'
import Browser from '../browser'

const BrowserFr = () => {
    return <Browser languageCode="en" />
}

export default BrowserFr
